import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text,
  Flex,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
} from '@chakra-ui/react'
import useMobile from '../../hooks/useMobile'
import { useState, useEffect } from 'react'

const SliderEditModal = ({
  isOpen,
  title,
  label,
  onClose,
  onSave,
  initialValue,
  isLoading,
}: {
  title: string
  label: string
  isOpen: boolean
  onClose: () => void
  onSave: (v: number) => void
  initialValue: number
  isLoading: boolean
}) => {
  const isMobile = useMobile(600)

  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody p="0">
          <Text variant="title" fontSize="2xl" fontWeight="500" mb="20px">
            {title}
          </Text>

          <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
            {label}
          </Text>
          <Text variant="subtle" mb="5px">
            Select the maximum available slots <span style={{ color: '#171C22' }}>120 slots</span>
          </Text>
          <Flex justifyContent="space-between">
            <Slider value={value} onChange={(v) => setValue(v)} w="80%" max={120} min={0}>
              <SliderTrack>
                <SliderFilledTrack />
              </SliderTrack>
              <SliderThumb />
            </Slider>
            <Text variant="title" fontSize="md">
              {value} slots
            </Text>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button variant="heavy" size="sm" isLoading={isLoading} onClick={() => onSave(value)}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default SliderEditModal
